var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C6.03167 14 5.12167 13.8161 4.27 13.4484C3.41833 13.0807 2.6775 12.582 2.0475 11.9525C1.4175 11.3225 0.918867 10.5817 0.5516 9.73C0.184333 8.87833 0.000466667 7.96833 0 7C0 6.03167 0.183867 5.12167 0.5516 4.27C0.919333 3.41833 1.41797 2.6775 2.0475 2.0475C2.6775 1.4175 3.41833 0.918867 4.27 0.5516C5.12167 0.184333 6.03167 0.000466667 7 0C7.96833 0 8.87833 0.183867 9.73 0.5516C10.5817 0.919333 11.3225 1.41797 11.9525 2.0475C12.5825 2.6775 13.0814 3.41833 13.4491 4.27C13.8168 5.12167 14.0005 6.03167 14 7C14 7.96833 13.8161 8.87833 13.4484 9.73C13.0807 10.5817 12.582 11.3225 11.9525 11.9525C11.3225 12.5825 10.5817 13.0814 9.73 13.4491C8.87833 13.8168 7.96833 14.0005 7 14ZM7 12.6C7.63 12.6 8.23667 12.498 8.82 12.2941C9.40333 12.0902 9.94 11.7955 10.43 11.41L2.59 3.57C2.205 4.06 1.9103 4.59667 1.7059 5.18C1.5015 5.76333 1.39953 6.37 1.4 7C1.4 8.56333 1.9425 9.8875 3.0275 10.9725C4.1125 12.0575 5.43667 12.6 7 12.6ZM11.41 10.43C11.795 9.94 12.0897 9.40333 12.2941 8.82C12.4985 8.23667 12.6005 7.63 12.6 7C12.6 5.43667 12.0575 4.1125 10.9725 3.0275C9.8875 1.9425 8.56333 1.4 7 1.4C6.37 1.4 5.76333 1.50197 5.18 1.7059C4.59667 1.90983 4.06 2.20453 3.57 2.59L11.41 10.43Z",
    fill: "#51CDA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.8fbbb4fd2e111f1310a4f44082ca6d76.svg";
export { ForwardRef as ReactComponent };